import {NgModule} from '@angular/core';
import {ErrorModule} from '@core/error/error.module';
import {ApiModule} from '@core/api/api.module';

@NgModule({imports: [ApiModule, ErrorModule]})
export class CoreModule {
}
